export default __webpack_public_path__ + "static/what-are-we-doing-1-2f732415ec16294635015b1d65b5cb0f.png";